import TemplateCommon from '../components/templates/TemplateCommon';
import TemplateGreed from '../components/templates/TemplateGreed';
import TemplateGreedNew from '../components/templates/TemplateGreedNew';
import TemplateDigitalSignage from '../components/templates/TemplateDigitalSignage';
import TemplateIssuing from "../components/templates/TemplateIssuing";
import TemplatePortrait from "../components/templates/TemplatePortrait";
import TemplatePortraitFrame from "../components/templates/TemplatePortraitFrame";
import TemplateFullFrame from "../components/templates/TemplateFullFrame";
import TemplateCommonNew from "../components/templates/TemplateCommonNew";
import TemplatePortraitNew from "../components/templates/TemplatePortraitNew";
import TemplatePortraitFrameNew from "../components/templates/TemplatePortraitFrameNew";
import TemplateFullFrameNew from "../components/templates/TemplateFullFrameNew";

export default Object.freeze({
  greed_2x3: {
    component: TemplateGreed,
    newComponent: TemplateGreedNew,
    isMirror: false,
    isAdditionalFrame: false
  },
  greed_l_frame_1: {
    component: TemplateCommon,
    newComponent: TemplateCommonNew,
    isMirror: false,
    isAdditionalFrame: false
  },
  greed_l_frame_1_mirror: {
    component: TemplateCommon,
    newComponent: TemplateCommonNew,
    isMirror: true,
    isAdditionalFrame: false
  },
  greed_1x4_frame_2: {
    component: TemplateCommon,
    newComponent: TemplateCommonNew,
    isMirror: false,
    isAdditionalFrame: true
  },
  greed_1x4_frame_2_mirror: {
    component: TemplateCommon,
    newComponent: TemplateCommonNew,
    isMirror: true,
    isAdditionalFrame: true
  },
  digital_signal: {
    component: TemplateDigitalSignage,
    newComponent: TemplateDigitalSignage,
    isMirror: false,
    isAdditionalFrame: false
  },
  issuing_point_grid: {
    component: TemplateIssuing,
    newComponent: TemplateIssuing,
    isMirror: false,
    isAdditionalFrame: false
  },
  portrait: {
    component: TemplatePortrait,
    newComponent: TemplatePortraitNew,
    isMirror: false,
    isAdditionalFrame: false
  },
  portrait_frame: {
    component: TemplatePortraitFrame,
    newComponent: TemplatePortraitFrameNew,
    isMirror: false,
    isAdditionalFrame: false
  },
  greed_4x1_video: {
    component: TemplateFullFrame,
    newComponent: TemplateFullFrameNew,
    isMirror: false,
    isAdditionalFrame: false
  },
});
